import { CreateChatSessionRequest } from '../lib';
import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export const createChatSession = async (
  request: CreateChatSessionRequest,
): Promise<string | null> => {
  const response = await post(ApiEndpoint.createChatSession, request);
  const data = response.data;
  if (!data || !data?.message?.toLowerCase().includes('success')) {
    return null;
  }

  return data.data;
};
